import { createGlobalStyle } from 'styled-components';

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

export default createGlobalStyle`
  /* @import url('https://fonts.googleapis.com/css?family=Montserrat:400,600&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons'); */


  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Montserrat'
  }

  *:focus{
    outline: 0;
  }

  html, body, #root{
    height: 100%
  }

  body{
    -webkit-font-smoothing: antialiased;
  }

  body, input, button{
    font-family: 'Montserrat', sans-serif
  }

  a{
    text-decoration: none;
  }

  ul{
    list-style: none;
  }

  button{
    cursor: pointer;
  }

  /* Removido: estava forçando z-index do modal para 0, causando problema com mapa */
  /* .modal-comp {
    z-index: 0 !important;
  } */
  
  /* Garantir que modais apareçam acima de mapas Leaflet */
  .modal-comp {
    z-index: 10000 !important;
  }
  
  /* Leaflet geralmente usa z-index até 1000, então 10000 garante que o modal apareça acima */
  .leaflet-container {
    z-index: 1;
  }
  
  .leaflet-pane {
    z-index: 400;
  }
  
  .leaflet-top,
  .leaflet-bottom {
    z-index: 1000;
  }

  /* Garantir que dropdowns do Autocomplete apareçam acima de outros elementos */
  .MuiAutocomplete-popper {
    z-index: 10001 !important;
  }

  .MuiAutocomplete-paper {
    z-index: 10001 !important;
  }

  .MuiAutocomplete-listbox {
    z-index: 10001 !important;
  }
`;
